var render = function () {
  var _vm$$route, _vm$$route$params, _vm$categories, _vm$$route2, _vm$$route2$params, _vm$categories2, _vm$$route3, _vm$$route3$params, _vm$items;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    staticClass: "main-container"
  }, [_c('page-header', {
    attrs: {
      "backgroundColor": "#00bcd4",
      "chipItems": (_vm$$route = _vm.$route) !== null && _vm$$route !== void 0 && (_vm$$route$params = _vm$$route.params) !== null && _vm$$route$params !== void 0 && _vm$$route$params.category && (_vm$categories = _vm.categories) !== null && _vm$categories !== void 0 && _vm$categories.length ? _vm.categories : [],
      "titleText": "LATEST ARRIVALS",
      "titleColor": _vm.$vuetify.theme.themes.light.secondary
    },
    on: {
      "input": _vm.onCategoryChange
    },
    model: {
      value: _vm.categorySelected,
      callback: function ($$v) {
        _vm.categorySelected = $$v;
      },
      expression: "categorySelected"
    }
  }), _c('v-row', {
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [!((_vm$$route2 = _vm.$route) !== null && _vm$$route2 !== void 0 && (_vm$$route2$params = _vm$$route2.params) !== null && _vm$$route2$params !== void 0 && _vm$$route2$params.category) || !_vm.categorySelected && (_vm$categories2 = _vm.categories) !== null && _vm$categories2 !== void 0 && _vm$categories2.length ? [_vm._l(_vm.categories, function (cat) {
    return _c('v-col', {
      key: cat.key,
      attrs: {
        "cols": "11",
        "md": "5"
      }
    }, [_c('v-card', {
      attrs: {
        "hover": ""
      },
      on: {
        "click": function ($event) {
          return _vm.onCategoryChange(cat.slug);
        }
      }
    }, [_c('v-card-text', {
      staticClass: "d-flex align-center font-weight-bold text-h6",
      staticStyle: {
        "color": "#00bcd4"
      }
    }, [_c('v-icon', {
      staticClass: "mr-4",
      attrs: {
        "color": "#00bcd4",
        "x-large": ""
      }
    }, [_vm._v("mdi " + _vm._s(cat.icon))]), _vm._v(" " + _vm._s(cat.label))], 1)], 1)], 1);
  }), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "5"
    }
  })] : _vm._e(), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "10",
      "lg": "8",
      "xl": "6"
    }
  }, [_vm.isLoading ? _c('v-sheet', {
    staticClass: "d-flex flex-column align-center justify-center",
    attrs: {
      "color": "transparent"
    }
  }, [_c('p', {
    staticClass: "text-center primary--text font-weight-bold"
  }, [_vm._v("Getting items...")]), _c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1) : _vm.error ? _c('v-sheet', {
    staticClass: "d-flex flex-column align-center justify-center rounded-lg",
    attrs: {
      "color": "transparent",
      "width": "auto"
    }
  }, [_c('p', {
    staticClass: "d-span text-center error--text font-weight-bold secondary rounded-pill py-4 px-8"
  }, [_vm._v(_vm._s(_vm.error))])]) : _vm.categorySelected && (_vm$$route3 = _vm.$route) !== null && _vm$$route3 !== void 0 && (_vm$$route3$params = _vm$$route3.params) !== null && _vm$$route3$params !== void 0 && _vm$$route3$params.category ? [_c('v-sheet', {
    staticClass: "d-flex align-center justify-center",
    attrs: {
      "color": "transparent",
      "width": "100%"
    }
  }, [_c('h2', {
    staticClass: "text-h4 secondary--text font-weight-bold text-left pl-4 pl-lg-0",
    staticStyle: {
      "max-width": "1200px",
      "width": "100%"
    }
  }, [_vm._v(_vm._s(_vm.month))])]), _c('new-material-item-list', {
    attrs: {
      "items": ((_vm$items = _vm.items) === null || _vm$items === void 0 ? void 0 : _vm$items[_vm.categorySelected]) || []
    }
  })] : _vm._e()], 2)], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }